import { REVIEWS } from '~/data/reviews';

/**
 * A continuously scrolling band of real Yelp pull-quotes.
 *
 * Sits directly under the hero so proof arrives before the pitch — Vikelas
 * asked for reviews "at the top", as a banner rather than a wall of cards.
 *
 * How the loop works: the track holds the reviews TWICE and translates by
 * exactly -50%. At that point copy 2 sits precisely where copy 1 started, so
 * the animation restarts with no visible jump. Rendering it twice is what
 * makes a seamless loop possible at all — one copy would snap back.
 *
 * The duplicate set is aria-hidden so a screen reader hears each review once.
 * The whole strip pauses on hover and stops entirely under reduced-motion,
 * where it becomes a normal horizontally scrollable row.
 *
 * ⚠️ Only ever render this for New Leaf. These are named clients quoting
 * Vikelas; on another tenant's site they would be that company claiming
 * someone else's customers. Callers gate on `branding.isNewLeaf`.
 */
export function ReviewMarquee() {
  const lane = [...REVIEWS, ...REVIEWS];

  return (
    <section className="rmq" aria-label="What our clients say">
      <div className="rmq__rail">
        <div className="rmq__track">
          {lane.map((r, i) => (
            <figure
              className="rmq__item"
              key={`${r.name}-${i}`}
              aria-hidden={i >= REVIEWS.length ? true : undefined}
            >
              <div className="rmq__stars" role="img" aria-label="5 out of 5 stars">
                <Stars />
              </div>
              <blockquote className="rmq__quote">{r.short}</blockquote>
              <figcaption className="rmq__by">
                <span className="rmq__name">{r.name}</span>
                <span className="rmq__meta">{r.location} · Yelp</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}

function Stars() {
  return (
    <>
      {Array.from({ length: 5 }, (_, i) => (
        <svg key={i} viewBox="0 0 24 24" width="13" height="13" fill="currentColor" aria-hidden="true">
          <path d="m12 2.5 2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.4 6.1 20.5l1.2-6.5L2.5 9.4l6.6-.9Z" />
        </svg>
      ))}
    </>
  );
}
